<template>
    <div id="photo-sidebar-menu" class="sidebar-menu-container">
        <div class="sidebar-main-label-grid">
            <span v-show="!showRenameInput" class="sidebar-main-label collapsable-ellipsis">{{nameActiveProject}}</span>
            <input v-show="showRenameInput" type="text" class="photo-sidebar-rename-project" :placeholder="nameActiveProject" v-model="inputName" v-on:change="renameProject">
            <span class="edit-project-name-container" v-on:click="showInputRename">
                <SVGEditProjectName/>
            </span>
        </div>
        <div v-for="(img, idPhoto) in ImagesProject" class="sidebar-project-img-container">
            <div class="pretty p-default sidebar-photo-checkbox">
                <input type="checkbox" v-on:click="selectCheckBox(idPhoto,$event)" :id="'cb_'+ idPhoto"/>
                <div class="state p-danger">
                    <label></label>
                </div>
            </div>
            <img class="sidebar-project-img" :src="urlForPhoto(img.src)" v-on:click.self="selectPhoto(idPhoto, $event)" v-on:dblclick.self="openPhoto(idPhoto)" :class="{'active-photo': idPhoto === idActivePhoto}"/>
        </div>
        <div id="new-photo-frame" v-on:click="showModal('photo-add-new-modal')">
            <SVGPhotoAddNew/>
        </div>
    </div>
</template>

<script>
    import {modalMethods, urlForStaticVue} from "../../common";
    import SVGEditProjectName from "../../SVG/SVGEditProjectName.vue";
    import SVGPhotoAddNew from "../../SVG/SVGPhotoAddNew.vue";

    export default {
        name: "PhotoSidebarMenu",
        components: {SVGPhotoAddNew, SVGEditProjectName},
        mixins: [urlForStaticVue, modalMethods],
        destroyed() {
            this.$store.commit("active/UNSELECT_ALL_PHOTO");
        },
        computed: {
            ImagesProject() {
                return this.$store.getters[`active/GET_ALL_PHOTO`];
            },
            nameActiveProject: {
                get: function () {
                    return this.$store.getters["active/NAME"];
                },
                set: function (newName) {
                    this.$store.dispatch("active/NAME", newName);
                }
            },
            idActivePhoto(){
                return this.$store.state.route.params.photoID;
            }
        },
        methods: {
            selectPhoto(idPhoto, event) {
                this.$router.replace({name: "viewPhoto", params: {photoID: idPhoto}}).catch(() => {})
                if (event.ctrlKey) {
                    document.getElementById('cb_'+ idPhoto).checked = !document.getElementById('cb_'+ idPhoto).checked
                    this.$store.commit("active/SELECT_PHOTO", idPhoto);
                }
            },
            openPhoto(idPhoto) {
                this.$router.push({name: "planeCategories", params: {photoID: idPhoto}}).catch(() => {})
            },
            urlForPhoto(url) {
                return this.$store.getters[`projectConfiguration/GENERATE_URL`](url);
            },
            selectCheckBox: function (idPhoto, event) {
                if (event.target.checked)
                    this.$store.commit("active/SELECT_PHOTO", idPhoto);
                else
                    this.$store.commit("active/UNSELECT_PHOTO", idPhoto);
            },
            showInputRename() {
                this.inputName = ''
                this.showRenameInput = !this.showRenameInput
            },
            renameProject() {
                this.$store.dispatch('active/NAME', this.inputName)
                this.showInputRename()
            }
        },
        data () {
            return {
                showRenameInput: false,
                inputName: ''
            }
        },
        watch: {
            ImagesProject() {
                let photosID = Object.keys(this.ImagesProject)
                if (photosID.length === 1 && this.$route.name === 'loadPhoto') {
                    this.$router.replace({name: "viewPhoto", params: {photoID: photosID[0]}}).catch(() => {})
                }
            },
        }
    }
</script>

<style scoped>
    #new-photo-frame {
        border: 2px dashed #ACACAC;
        height: 158px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #ACACAC;
        margin: 20px 0;
    }

    #new-photo-frame:hover {
        color: #909090;
    }

    #new-photo-frame:active {
        color: #ACACAC;
    }

    .sidebar-project-img-container {
        margin: 10px 0;
        user-select: none;
    }

    .sidebar-photo-checkbox {
        /*background-color: white;*/
        right: -253px;
        top: 25px;
    }
</style>
